import PropTypes from "prop-types";
import React from "react";

import { Card } from "@/component-library/Card";
import { cn } from "@/lib/helpers/cn";

import "./styles.scss";

export const TwoButtonCard = ({ buttonLeft, buttonRight, children, className, ...props }) => (
  <Card className={cn("apti-CL", "apti-TwoButtonCard", className)} {...props}>
    {children}
    <div className="apti-TwoButtonCard-button-container tw:flex tw:justify-center tw:gap-8">
      {buttonLeft}

      {buttonRight}
    </div>
  </Card>
);

TwoButtonCard.propTypes = {
  buttonLeft: PropTypes.element,
  buttonRight: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

TwoButtonCard.defaultProps = {
  children: <> </>,
  className: undefined,
  onClick: () => {},
};
